import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/lib/integration/react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <App></App>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

/**
 TODO - User page dynamic
 TODO - Feedback page dynamic
 TODO - Image in company 
 TODO - Create advertising object automatically
 */
